import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';

@Component({
  selector: 'app-modal-detalle-movimientos',
  templateUrl: './modal-detalle-movimientos.component.html',
  styleUrls: ['./modal-detalle-movimientos.component.scss'],
  providers: [SecurityService],
})
export class AnalisisDemandaModalDetalleMovimientosComponent implements OnInit {

  // Modales
  @ViewChild('detalleMov', { static: true }) modalDetalleMov: ModalDirective;

  movimiento: any
  constructor() { }

  ngOnInit() {
  }

  public loadAndShow(movimiento) {
    this.movimiento = movimiento
    this.modalDetalleMov.show()
  }

}
